import React from 'react'
import {
    DrawerBody,
    ExampleContainer,
    ExampleItem,
    ExampleItemContainer,
    ExampleItemText,
    ExamplePlateItem,
    ExampleTitle,
    ExplanationContainer,
    ExplanationItem,
    HelpTitle
} from './HelpDrawer.style'
import { Example1, Example2, Example3, Example4, Example5, ExampleArrow } from '@assets'
import Drawer from '@components/Drawer/Drawer.component'
import { useTranslation } from 'react-i18next'

interface HelpDrawerProps {
    isOpen: boolean
    onClose: () => void
}

const HelpDrawer = ({ isOpen, onClose }: HelpDrawerProps) => {
    const { t } = useTranslation()

    return (
        <Drawer
            animate={true}
            showBackdrop={true}
            onClose={onClose}
            isOpen={isOpen}
            content={
                <>
                    <HelpTitle>{t('carpay.help.title')}</HelpTitle>

                    <ExplanationContainer>
                        <ExplanationItem>{t('carpay.help.explanation')}</ExplanationItem>
                        <ExplanationItem>{t('carpay.help.explanation2')}</ExplanationItem>
                        <ExplanationItem>{t('carpay.help.explanation3')}</ExplanationItem>
                        <ExplanationItem>{t('carpay.help.explanation4')}</ExplanationItem>
                        <ExplanationItem>{t('carpay.help.explanation5')}</ExplanationItem>
                    </ExplanationContainer>

                    <ExampleContainer>
                        <ExampleTitle>{t('carpay.help.examples')}</ExampleTitle>

                        <ExampleItemContainer>
                            <ExampleItem>
                                <ExamplePlateItem alt="Example plate DE" src={Example3} />
                                <img src={ExampleArrow} alt="Example arrow" />
                                <ExampleItemText>HHKFZ023</ExampleItemText>
                            </ExampleItem>
                            <ExampleItem>
                                <ExamplePlateItem alt="Example 2 plate DE" src={Example4} />
                                <img src={ExampleArrow} alt="Example arrow" />
                                <ExampleItemText>MBD14E</ExampleItemText>
                            </ExampleItem>
                            <ExampleItem>
                                <ExamplePlateItem alt="Example plate AT" src={Example1} />
                                <img src={ExampleArrow} alt="Example arrow" />
                                <ExampleItemText>W24681R</ExampleItemText>
                            </ExampleItem>
                            <ExampleItem>
                                <ExamplePlateItem alt="Example plate CH" src={Example2} />
                                <img src={ExampleArrow} alt="Example arrow" />
                                <ExampleItemText>BE56789</ExampleItemText>
                            </ExampleItem>
                            <ExampleItem>
                                <ExamplePlateItem alt="Example plate France" src={Example5} />
                                <img src={ExampleArrow} alt="Example arrow" />
                                <ExampleItemText>AA229AA</ExampleItemText>
                            </ExampleItem>
                        </ExampleItemContainer>
                    </ExampleContainer>
                </>
            }
        />
    )
}

export default HelpDrawer
